import type { ButtonPriority } from '@timelyapp/react';
import type { DropdownOption } from 'components/DropdownListWithOptions';
import DropdownListWithOptions from 'components/DropdownListWithOptions';
import type { Props as PopoverProps } from 'components/popovers/Popover';
import Popover from 'components/popovers/Popover';
import React, { Component } from 'react';
import type { Merge } from 'types/utility';

export type Option = DropdownOption;
interface OwnProps<T extends DropdownOption> {
  /** Should the popover close when clicking it? */
  closeOnClick?: boolean;
  /** List of options that will be displayed */
  options: ReadonlyArray<T>;
  /** This will be called when an option is clicked */
  onClick: (option: T, event: React.SyntheticEvent) => void;
  /** This will be called when the popover becomes hidden */
  onClose?: () => void;
  enableKeyTrap?: boolean;
  confirmButtonPriority?: ButtonPriority;
}

export type Props<T extends DropdownOption> = Merge<PopoverProps, OwnProps<T>>;

export default class PopoverDropdownList<T extends Readonly<DropdownOption>> extends Component<
  Props<T>
> {
  static defaultProps = {
    options: [],
    closeOnClick: true,
    onClick: () => {},
    onClose: () => {},
    position: 'bottom',
  };

  render() {
    const { options, onClick, position, stopPropagation, confirmButtonPriority, ...rest } =
      this.props;

    return (
      <Popover position={position} stopPropagation={stopPropagation} {...rest}>
        <DropdownListWithOptions
          confirmButtonPriority={confirmButtonPriority}
          options={options}
          onClick={onClick}
        />
      </Popover>
    );
  }
}
